import { useTranslation } from 'next-i18next';
import getConfig from 'next/config';
import Image from 'next/image';
import { useRef, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { wrapEvent } from '../../helper';
import SuccessIcon from '../../public/img/icons/icon_success.svg';
import DownloadForm from '../common/DownloadForm';
import Icon from '../common/Icon';

const {
  publicRuntimeConfig: { imagesSrc },
} = getConfig();

const CONTENT_OVERVIEW = [
  {
    bullet: [1, 2, 3, 4],
    image: '/img/screens/charts.png',
  },
  {
    bullet: [1, 2, 3, 4],
    image: '/img/screens/depth-of-market.png',
  },
  {
    bullet: [1, 2, 3, 4],
    image: '/img/screens/trade-feed.png',
  },
  {
    bullet: [1, 2, 3, 4],
    image: '/img/screens/statistics.png',
  },
  {
    image: '/img/screens/quotes.png',
    bullet: [],
  },
  {
    image: '/img/screens/analytics.png',
    bullet: [],
  },
  {
    image: '/img/screens/playback.png',
    bullet: [],
  },
  {
    image: '/img/screens/risk-manager.png',
    bullet: [],
  },
];

const addRef = (list, index) => (ref) => {
  list.current[index] = ref;
};

const toElement = (index, elements) => {
  const el = elements.current[index];
  const top = el.offsetTop - 65;
  window.scrollTo({
    top,
    behavior: 'smooth',
  });
};

const Overview = () => {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const contentRef = useRef([]);
  const [isOpen, setIsOpen] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);

  const handlerCreator = (index) => () => {
    setIsOpen(true);
    setImgIndex(index);
  };

  return (
    <div className="content">
      {/* <BlackFriday isInternalPage={true} /> */}
      <div className="big-title">
        <h1>{t('overview_welcome_header')}</h1>
        <div className="text">{t('overview_welcome_text')}</div>
      </div>
      <div className="features-list">
        <ol>
          {CONTENT_OVERVIEW.map(({ image }, index) => {
            const num = index + 1;
            return (
              <li key={image}>
                <h2>{t(`overview_chapter${num}_header`)}</h2>
                {t(`overview_chapter${num}_shortText`)}
                <strong>
                  {' '}
                  <a
                    className="nowrap"
                    href={`#${t(`overview_chapter${num}_header`)}`}
                    onClick={wrapEvent(toElement, index, contentRef)}
                  >
                    {t('overview_learnMore')}
                  </a>
                </strong>
              </li>
            );
          })}
        </ol>
      </div>
      <div className="features">
        {CONTENT_OVERVIEW.map(({ image, bullet }, index) => {
          const num = index + 1;

          return (
            <div
              className="el"
              key={image}
              id={t(`overview_chapter${num}_header`)}
              ref={addRef(contentRef, index)}
            >
              <h2>{t(`overview_chapter${num}_header`)}</h2>
              {!!isOpen && (
                <Lightbox
                  mainSrc={`${imagesSrc}/img/overview/${lng}_overview_${imgIndex}.png`}
                  onCloseRequest={() => setIsOpen(false)}
                  enableZoom={false}
                  imagePadding={30}
                />
              )}
              <figure className="image" onClick={handlerCreator(num)}>
                <Image
                  src={`/img/overview/${lng}_overview_${num}.png`}
                  width="720"
                  height="460"
                  alt={t(`overview_chapter${num}_header`)}
                />
                <span className="zoom-pic">
                  <Icon name="30-zoom" file="sprite" width="30" height="30" />
                </span>
              </figure>
              <div className="text">{t(`overview_chapter${num}_text`)}</div>
              {!!bullet.length && (
                <ul>
                  {bullet.map((i) => (
                    <li className="overview-text" key={i}>
                      <SuccessIcon className="overview-success-icon" />
                      <span>{t(`overview_chapter${num}_bullet${i}`)}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
      <DownloadForm inputId="3155" btnId="0143" />
    </div>
  );
};

export default Overview;
